import React, { useEffect, useMemo, useRef } from 'react'
import Axios from 'axios'
import { connectQuery } from '@findify/react-connect/lib'
import classes from './SearchCollectionResults.module.scss'
import Highlighter from 'react-highlight-words'
import { useMedia } from '../../hooks'
import { trackCustomEventThenRedirect } from '../../utils/analytics'

const SearchCollectionResults = connectQuery(({ query }) => {

    const index = useRef(null)
    const q = query.get('q')
    const isMobile = useMedia('(max-width: 991.8px)')

    useEffect(() => {
        (async function () {
            const { default: FlexSearch } = await import('flexsearch')
            index.current = new FlexSearch({
                doc: {
                    id: 'id',
                    field: [
                        'name'
                    ]
                }
            });
            const { data } = await Axios.get('/export/cs/categorySearchIndex.json')
            Object.entries(data).forEach(([id, category]) => index.current.add({ id, ...category }))
        })();
        return () => {
            if (index.current) {
                index.current.destroy()
            }
        };
    }, [])

    const results = useMemo(() => {
        if (q && index.current) {
            return index.current.search({
                query: q,
                limit: 8,
            })
        }
        return []
    }, [q])

    if (results.length === 0 || isMobile) return null

    return (
        <>
            <h3 className={classes.label}>Top Categories</h3>
            <ul className={classes.list}>
                {results.map(({ name, url, id }) => <li key={id}>
                    <a href={url} onClick={trackCustomEventThenRedirect({ category: "UX", action: "Click", label: "Category Search", value: name, url })}>
                        <Highlighter
                            highlightTag="b"
                            searchWords={q.split(' ')}
                            textToHighlight={name}
                            autoEscape
                        />
                    </a>
                </li>
                )}
            </ul>
        </>
    )
})

export default SearchCollectionResults